import { FormattedMessage } from 'react-intl';

export const loginMessages = {
  'login.fetchAccessToken.unexpctedError': (
    <FormattedMessage
      id="login.fetchAccessToken.unexpctedError"
      defaultMessage="There was an error fetching your access token. Please refresh your browser to try again, or contact support."
    />
  ),
};

export const acceptEulaMessages = {
  'acceptEula.unexpctedError': (
    <FormattedMessage
      id="acceptEula.unexpctedError"
      defaultMessage="Error saving your acceptance of terms and conditions. Please try again or contact support."
    />
  ),
};

export const submitSurveyMessages = {
  'submitSurvey.unexpctedError': (
    <FormattedMessage
      id="submitSurvey.unexpctedError"
      defaultMessage="Error submitting your survey. Please try again or contact support."
    />
  ),
};
